import { Trans } from '@lingui/react/macro';
import { TireQuoteRecordList } from '@navio/nsdk';
import { useState } from 'react';

import { AcceptedDetailPanel } from './AcceptedDetailPanel';
import { AcceptedRow } from './AcceptedRow';

type AcceptedTabProps = {
  offers: TireQuoteRecordList[];
};

export const AcceptedTab = ({ offers }: AcceptedTabProps) => {
  const [selected, setSelected] = useState<TireQuoteRecordList | null>(null);

  if (offers.length === 0) {
    return (
      <div className='rounded-xl border border-border bg-card p-12 text-center'>
        <div className='text-base font-semibold text-foreground'>
          <Trans>No accepted offers yet</Trans>
        </div>
        <div className='mt-1 text-sm text-muted-foreground'>
          <Trans>When you accept tire offers they'll appear here so you can track delivery and mounting.</Trans>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-4'>
      <div className='overflow-hidden rounded-xl border border-border bg-card shadow-xs'>
        <div className='hidden grid-cols-[minmax(180px,260px)_1fr_60px_140px_minmax(80px,1fr)] items-center gap-4 border-b border-border bg-muted px-4 py-2.5 text-[11px] font-medium tracking-wider text-muted-foreground uppercase md:grid'>
          <div>
            <Trans>Vehicle</Trans>
          </div>
          <div>
            <Trans>Season</Trans>
          </div>
          <div className='text-center'>
            <Trans>Qty</Trans>
          </div>
          <div>
            <Trans>Status</Trans>
          </div>
          <div className='text-right'>
            <Trans>Reference</Trans>
          </div>
        </div>

        {offers.map((offer) => (
          <AcceptedRow key={offer.id} offer={offer} onOpen={setSelected} />
        ))}
      </div>

      <AcceptedDetailPanel offer={selected} onClose={() => setSelected(null)} />
    </div>
  );
};
